// Routes that use the minimal "enclosed" layout: a slim header (logo, secure
// checkout, help) and none of the store chrome (mega-menu, footer, bottom
// nav, floating buttons, pop-ups). Used by components/ChromeGate.
const MINIMAL_CHROME = [/^\/checkout(\/|$)/];

export const isMinimalChromePath = (pathname) => MINIMAL_CHROME.some((re) => re.test(String(pathname || '')));
